import { RefObject } from "react";
import ReviewItem from "./review-item";
import type { ReviewDiscoveryListQuery } from "../../../__generated__/graphql";

interface ExploreReviewListProps {
  allReviews: ReviewDiscoveryListQuery["reviewDiscoveryList"];
  hasMore: boolean;
  isLoadingMore: boolean;
  expandedReviews: Set<number>;
  imageLoaded: Record<number, boolean>;
  onToggleReview: (reviewId: number) => void;
  onImageLoad: (reviewId: number) => void;
  rootRef: RefObject<HTMLDivElement>;
  loadMoreRef: RefObject<HTMLDivElement>;
  attachObserver: (el: HTMLDivElement | null, reviewId: number) => void;
}

export function ExploreReviewList({
  allReviews,
  hasMore,
  isLoadingMore,
  expandedReviews,
  imageLoaded,
  onToggleReview,
  onImageLoad,
  rootRef,
  loadMoreRef,
  attachObserver,
}: ExploreReviewListProps) {
  return (
    <>
      {allReviews.map((review) => (
        <div
          key={review.id}
          ref={(el) => attachObserver(el, review.id)}
        >
          <ReviewItem
            review={review}
            expandedReviews={expandedReviews}
            imageLoaded={imageLoaded}
            onToggleReview={onToggleReview}
            onImageLoad={onImageLoad}
            rootRef={rootRef}
          />
        </div>
      ))}

      {hasMore && (
        <div
          ref={loadMoreRef}
          className="flex justify-center items-center py-12 px-4"
        >
          {isLoadingMore && (
            <div className="flex items-center gap-2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
              <span className="text-gray-600">불러오는 중...</span>
            </div>
          )}
        </div>
      )}
    </>
  );
}
